var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"img_box_box",on:{"click":function($event){_vm.visible = false}}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img_box"},[_c('img',{attrs:{"src":require("../assets/xcxCode.png")}})])
}]

export { render, staticRenderFns }